import React from "react";
import MainMenu from "../../components/MainMenu";
import Button from "@mui/material/Button";
import { Grid, Paper } from "@mui/material";
import NewPlayerCard from "../../components/PlayersAreaComponents/NewPlayerCard/NewPlayerCard";

function PlayerRegistration() {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <NewPlayerCard />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
}

export default PlayerRegistration;
